const DRAWER_MENU_TEST_IDS = {
  ARROW: 'arrow-button',
  CONTAINER: 'drawer-menu',
};

export default DRAWER_MENU_TEST_IDS;
